import { useContext, useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { Helmet } from "react-helmet-async";
import { useOutletContext } from "react-router";
import { useProject } from "../../../utils/hooks/useProject";
import Input from "../../../utils/components/Input";
import API from "../../../utils/API";
import Modal from "../../../utils/components/Modal";
import Sets from "./Sets";
import { confirmAlert } from "react-confirm-alert";
import AlertModal from "../../../utils/components/AlertModal";
import { RequestContext } from "../../../utils/context/RequestContext";

const RevisionSets = () => {
  const [revisionSets, setRevisionSets] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [revisionSetName, setRevisionSetName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { project } = useProject();

  const [translate] = useOutletContext();

  const { setRequestLoading, requestLoading } = useContext(RequestContext);

  useEffect(() => {
    if (project?.id)
      API.getData(`revision_sets?project_id=${project.id}`).then(
        ({ data: res }) => {
          setTimeout(() => {
            const data = res.data.map((item) => {
              return {
                id: item.id,
                title: item.name,
                subTree: item.details,
                hasDetail: item.is_details,
              };
            });

            setRevisionSets(data);
          }, 20);

          setTimeout(() => {
            setIsLoading(false);
          }, 50);
        }
      );
    else setIsLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (requestLoading) return;

    if (!revisionSetName.trim() || !project) {
      confirmAlert({
        customUI: ({ onClose }) => (
          <AlertModal
            buttons={[
              {
                label: translate("okay"),
                onClick: onClose,
                classNames: "btn btn-primary",
              },
            ]}
            message={translate("fill_all_fields")}
          />
        ),
      });
      return false;
    }

    setRequestLoading(true);

    const body = {
      name: revisionSetName.trim(),
      project_id: project.id,
    };

    API.postData(`revision_sets`, body).then(({ data: res }) => {
      const { data } = res;

      const newItem = {
        id: data.id,
        title: data.name,
        subTree: [],
      };

      setRevisionSets([...revisionSets, newItem]);

      setShowModal(false);
      setRevisionSetName("");
    });
  };

  const onDelete = (id) => {
    if (!id) return false;

    confirmAlert({
      customUI: ({ onClose }) => (
        <AlertModal
          buttons={[
            {
              label: translate("cancel"),
              onClick: onClose,
              classNames: "btn btn-secondary",
            },
            {
              label: translate("delete"),
              onClick: () => {
                handleDelete(id, onClose);
              },
              classNames: "btn btn-danger",
            },
          ]}
          message={translate("delete_confirmation")}
        />
      ),
    });
  };

  const handleDelete = (id, closeModal) => {
    if (requestLoading) return;
    setRequestLoading(true);

    API.deleteData(`revision_set/${id}`).then(() => {
      const newRevisionSets = revisionSets.filter((item) => item.id !== id);
      setRevisionSets(newRevisionSets);
      closeModal();
    });
  };

  const handleAddDetail = (parent_id, body, callback = null) => {
    if (parent_id && body) {
      if (!body.name.trim()) {
        confirmAlert({
          customUI: ({ onClose }) => (
            <AlertModal
              buttons={[
                {
                  label: translate("okay"),
                  onClick: onClose,
                  classNames: "btn btn-primary",
                },
              ]}
              message={translate("fill_all_fields")}
            />
          ),
        });
        return false;
      }

      setRequestLoading(true);

      body = {
        name: body.name.trim(),
      };
      API.postData(`revision_set/${parent_id}/details`, body).then(
        ({ data: res }) => {
          const { data } = res;

          const newItem = {
            id: data.id,
            name: data.name,
            set_id: parent_id,
          };

          const sets = [...revisionSets];

          const index = sets.findIndex((item) => item.id === parent_id);

          if (index > -1) {
            sets[index].subTree = [...sets[index].subTree, newItem];
            setRevisionSets(sets);
          }

          if (callback) callback(newItem);
        }
      );
    }
  };

  return (
    <div className="RevisionSets SetsPage">
      <Helmet>
        <title>
          {translate("page_titles.project-settings-revision-sets")} -{" "}
          {translate("page_titles.project-settings")}
        </title>
      </Helmet>
      <div className="row">
        <div className="col-12 d-flex">
          <div
            className="d-flex align-items-center mb-4"
            role="button"
            onClick={() =>
              project?.id
                ? setShowModal(true)
                : alert(translate("select_a_project_alert"))
            }
          >
            <BiPlus className="fs-1 bg-primary text-white rounded-circle" />
            <span className="ms-2">
              {translate(
                "project_settings.revision_sets.create_new_set_button"
              )}
            </span>
          </div>
        </div>
      </div>
      {project?.id ? (
        <>
          <div className="row">
            <div className="col-12">
              <Sets
                sets={revisionSets}
                setsLoading={isLoading}
                handleDelete={onDelete}
                handleAddDetail={handleAddDetail}
                type="REVISION_SET"
              />
            </div>
          </div>

          <Modal
            title={translate("project_settings.revision_sets.create_new_set")}
            positiveButtonNode={translate("save")}
            negativeButtonNode={translate("cancel")}
            positiveButtonHandler={handleSubmit}
            modalSize="lg"
            show={showModal}
            setShow={(show) => {
              setShowModal(show);
            }}
          >
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <Input
                  type="text"
                  name="revisionSetName"
                  title={translate("project_settings.revision_sets.set_name")}
                  placeholder={translate(
                    "project_settings.revision_sets.set_name_placeholder"
                  )}
                  value={revisionSetName}
                  onChange={(e) => setRevisionSetName(e.target.value)}
                />
              </div>
            </form>
          </Modal>
        </>
      ) : (
        ``
      )}
    </div>
  );
};
export default RevisionSets;
